import { createSelectOptionColorPicker } from '@streamlain/database-identity';

interface SelectTag {
  id: string;
  value: string;
  color: string;
}

function createTagId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function createSelectColumnOptions(
  values: readonly string[]
): SelectTag[] {
  const pickSelectOptionColor = createSelectOptionColorPicker();
  return values.map(value => ({
    id: createTagId(),
    value,
    color: pickSelectOptionColor(),
  }));
}
